'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _last = require('lodash/last');

var _last2 = _interopRequireDefault(_last);

var _omitBy = require('lodash/omitBy');

var _omitBy2 = _interopRequireDefault(_omitBy);

var _events = require('./events');

var _extractDataFromEvent = require('./extract-data-from-event');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getActionSubjectForEventType = function getActionSubjectForEventType(event, analyticsType) {
    if (analyticsType === _events.TRACK_EVENT_TYPE) {
        return (0, _extractDataFromEvent.getActionSubject)(event);
    }
    return (0, _last2.default)((0, _extractDataFromEvent.getComponents)(event));
};

/**
 * This util exists to bridge the two different formats between atlaskit and the data services events. Two formats are required because
 * atlaskit needs to be able to collect aribtrary events from the tree while the data service event doesn't (and shouldn't) care about the react tree.
 *
 * AtlasKit event format:
 *
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Data Services event format:
 *  event {
 *      type: <"TRACK"|"SCREEN"|"UI"|"OPERATIONAL">
 *      payload {
 *          ...mandatoryFieldsBasedOnEventType
 *          ...optionalFieldsBasedOnEventType
 *          attributes: {
 *              ...arbirtaryAttributes
 *          }
 *      }
 *  }
 */


exports.default = function (event) {
    var sources = (0, _extractDataFromEvent.getSources)(event);

    var analyticsType = (0, _extractDataFromEvent.getAnalyticsType)(event);
    var actionSubject = getActionSubjectForEventType(event, analyticsType);

    var source = (0, _last2.default)(sources);
    var action = (0, _extractDataFromEvent.getAction)(event);

    var attributes = (0, _extends3.default)({}, (0, _extractDataFromEvent.getAttributes)(event), {
        namespaces: sources.join('.')
    });

    if (action === _events.PAGE_EVENT_ACTION || analyticsType === _events.SCREEN_EVENT_TYPE) {
        return {
            type: _events.SCREEN_EVENT_TYPE,
            payload: {
                name: source,
                attributes: attributes
            }
        };
    }

    switch (analyticsType) {
        case _events.UI_EVENT_TYPE:
        case _events.TRACK_EVENT_TYPE:
        case _events.OPERATIONAL_EVENT_TYPE:
            {
                var actionSubjectId = (0, _extractDataFromEvent.getActionSubjectId)(event);
                var containerId = (0, _last2.default)((0, _extractDataFromEvent.getContainerIds)(event));
                var containerType = (0, _last2.default)((0, _extractDataFromEvent.getContainerTypes)(event));
                var objectId = (0, _last2.default)((0, _extractDataFromEvent.getObjectIds)(event));
                var objectType = (0, _last2.default)((0, _extractDataFromEvent.getObjectTypes)(event));
                var tags = (0, _extractDataFromEvent.getTags)(event);
                return {
                    type: analyticsType,
                    payload: (0, _omitBy2.default)({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, _isUndefined2.default)
                };
            }
        default:
            {
                return {
                    payload: {
                        source: source,
                        actionSubject: actionSubject,
                        attributes: attributes
                    },
                    type: undefined
                };
            }
    }
};